import { runInAction } from 'mobx';

import Tasks from 'APP/Tasks';
import { clearGroupHistoryForMe, clearGroupHistoryForAll } from 'APP/model/group/groupModel';
import { Counter } from 'APP/store/CountersStore/Counter';
import { Group } from 'APP/store/Groups/Group';
import { MessagesStore } from 'APP/store/Messages/Messages';
import { PinnedMessages } from 'APP/store/Messages/PinnedMessages/PinnedMessages';
import { SharedData } from 'APP/store/SharedData/SharedData';
import Entities from 'STORE';

interface IGroupMessagesState {
  messageStore: MessagesStore;
  sharedData: SharedData;
  pinnedMessages: PinnedMessages;
  counter: Counter | null;
}

interface IRestoreGroupMessagesState extends IGroupMessagesState {
  group: Group;
}

function saveGroupState(group: Group): IGroupMessagesState {
  const messageStore = group.messagesStore;
  const sharedData = group.sharedData;
  const pinnedMessages = group.pinnedMessages;
  const counter = group.counter;

  return { messageStore, sharedData, pinnedMessages, counter };
}

function clearGroupMessages(group: Group, clearHistoryTs: number): void {
  runInAction(() => {
    group.messagesStore = new MessagesStore(group);
    group.sharedData = new SharedData(group);
    group.sharedData = new SharedData(group);

    if (!group.counter) {
      return;
    }

    Entities.Counters.add(
      new Counter({
        groupId: group.id,
        counter: 0,
        seenTs: group.counter.seenTs,
        unreadUserMentionsCounter: 0,
        lastUserMentionTs: 0,
        clearHistoryTs,
      })
    );
  });
}

function restoreGroupState({
  group,
  messageStore,
  sharedData,
  pinnedMessages,
  counter,
}: IRestoreGroupMessagesState): void {
  runInAction(() => {
    group.messagesStore = messageStore;
    group.sharedData = sharedData;
    group.pinnedMessages = pinnedMessages;

    if (!group.counter || !counter) {
      return;
    }

    Entities.Counters.add(counter);
  });
}

interface IClearHistoryParams {
  groupId: string;
  isClearForAll?: boolean;
}

export async function clearHistory({
  groupId,
  isClearForAll = false,
}: IClearHistoryParams): Promise<void> {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return;
  }

  const request = isClearForAll ? clearGroupHistoryForAll : clearGroupHistoryForMe;
  const prevGroupState = saveGroupState(group);
  const clearTimestamp = Date.now();

  clearGroupMessages(group, clearTimestamp);

  try {
    const result = await request({ groupId: group.id });
    if (result.result) {
      // ToDo need clearing history when the field clearHistoryTs in counter will be changed
      Tasks.messaging.clearHistoryLocally(group.id, clearTimestamp);
    }
  } catch {
    restoreGroupState({ ...prevGroupState, group });
  }
}
